import { render, staticRenderFns } from "./AddTagModal.vue?vue&type=template&id=06249dde&scoped=true&"
import script from "./AddTagModal.vue?vue&type=script&lang=js&"
export * from "./AddTagModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTagModal.vue?vue&type=style&index=0&id=06249dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06249dde",
  null
  
)

export default component.exports